(function() {
  class FreeShippingProgressfreeshipping extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold);
      this.boundRefresh = this.refresh.bind(this);

      document.addEventListener('cart:updated', this.boundRefresh);
      document.addEventListener('cart-update', this.boundRefresh);
      document.addEventListener('cart:open', this.boundRefresh);
      document.addEventListener('on:cart-drawer:open', this.boundRefresh);
      this.interval = window.setInterval(this.boundRefresh, 1500);

      this.initRetry();
    }

    initRetry(attempts = 0) {
      this.message = this.querySelector('.ai-shipping-progress__message-freeshipping');
      this.fill = this.querySelector('.ai-shipping-progress__fill-freeshipping');
      this.track = this.querySelector('.ai-shipping-progress__track-freeshipping');

      if (this.message && this.fill && this.track) {
        this.refresh();
      } else if (attempts < 10) {
        setTimeout(() => this.initRetry(attempts + 1), 100);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.boundRefresh);
      document.removeEventListener('cart-update', this.boundRefresh);
      document.removeEventListener('cart:open', this.boundRefresh);
      document.removeEventListener('on:cart-drawer:open', this.boundRefresh);
      window.clearInterval(this.interval);
    }

    refresh() {
      if (!this.message || !this.fill || !this.track) return;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => this.render(cart.total_price))
        .catch(() => {});
    }

    render(total) {
      const threshold = this.threshold;
      const complete = total >= threshold;
      const percentage = Math.min((total / threshold) * 100, 100);
      const remaining = Math.max(threshold - total, 0) / 100;
      const amount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(remaining);
      this.fill.style.width = percentage + '%';
      this.fill.dataset.complete = complete ? 'true' : 'false';
      this.track.setAttribute('aria-valuenow', String(Math.min(total, threshold)));
      this.message.textContent = complete
        ? this.dataset.completeMessage
        : this.dataset.awayTemplate.replace('[amount]', amount);
    }
  }

  if (!customElements.get('free-shipping-progress-freeshipping')) {
    customElements.define('free-shipping-progress-freeshipping', FreeShippingProgressfreeshipping);
  }

  const observer = new MutationObserver(() => {
    const el = document.querySelector('free-shipping-progress-freeshipping');
    if (el && typeof el.initRetry === 'function') {
      el.initRetry();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
